/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { BarChart,Bar, XAxis, YAxis, CartesianGrid, Tooltip, Label, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

import { setCurrencyFormat, colorsCombination, colorArray } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
    console.log('d')
    // eslint-disable-next-line react/prop-types
    const { active, payload } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
        // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
        return null
    }

    const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1).map((item) => {
        const updated = { ...item }
console.log('k')
        if (item.name === "Amount") {
            updated.name = 'Total Amount';
        }
        updated.value = setCurrencyFormat(Number(item?.value).toFixed(2), true);

        console.log(updated)
        return updated;
        
    });
    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
};

const SalesBreakdownByProductBarChart = ({ dir, showTitle, categorisedBasedOn, index,
    dataToShow, height, category, allCategories }) => {
        console.log(dataToShow)
    const thisMonthData = {};
    const currentDataByYear = {};
    const [color1, color2, color3] = colorsCombination[index % 10];

    const currentCatData = Object.keys(dataToShow);    
    const dataToPlot = [];    
    return (         
         <ResponsiveContainer height={height}>
         <BarChart
             data={dataToShow}
             margin={{
             top: 60, right: 0, left: 25, bottom: 0,
             }}
         >
             <XAxis dataKey="day"  />
             <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                 tickFormatter={item => setCurrencyFormat(item, true)}
                 width={90}
                 dataKey="Amount"
                 allowDataOverflow
             />
             <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
             <Tooltip content={<CustomTooltip
                                    allCategories={allCategories}/>}
                                />
             {/* <Tooltip formatter={value => setCurrencyFormat(value, true)} /> */}
             <Legend />
             {allCategories && Object.keys(allCategories).sort((a, b) =>
                                 a?.toLowerCase() > b?.toLowerCase() ? 1 : -1).map((categ, ind) => (
                                    <Bar key={categ}
                                        stackId="a"
                                        dataKey={categ.toString()}
                                        barSize={40} fill={colorArray[ind]} />
                                ))}
             {/* {dataToShow?.map((label, lineIndex) => (
                 <Bar stackId="a"
                  dataKey={label.name.toString()} data={label.data} key={label.name} fill={label.color || '#3366ff'} barSize={400} />
             ))} */}
            
         </BarChart>
     </ResponsiveContainer>
    )
}

SalesBreakdownByProductBarChart.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShow: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    category: PropTypes.string.isRequired,
    categorisedBasedOn: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    allCategories: PropTypes.object.isRequired
    // eslint-disable-next-line react/forbid-prop-types
};

SalesBreakdownByProductBarChart.defaultProps = {
    showTitle: true
  }

export default React.memo(SalesBreakdownByProductBarChart);